let currentLandingPageId: string | null = null;
let landingPageData: any = null;
let landingPageContent: any = null;

// 🔄 LandingPage ID
export function setLandingPageId(id: string) {
  currentLandingPageId = id;
}

export function getLandingPageId(): string | null {
  return currentLandingPageId;
}

// 🔄 LandingPage Daten (z. B. { isActive: true, theme: 'dark' })
export function setLandingPageData(data: any): void {
  landingPageData = data;
}

export function getLandingPageData(): any {
  return landingPageData;
}

// 🔄 LandingPage PageBuilder-Inhalt
export function setLandingPageContent(data: any): void {
  landingPageContent = data;
}

export function getLandingPageContent(): any {
  return landingPageContent;
}
